import React from "react";
import { Button, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

const UpdateDateDialog = ({ internshipSessionId, defenseDate, fetchThesisDefenseInfo }) => {
  const notify = useNotify();
  const isEdit = defenseDate !== null && defenseDate !== undefined && defenseDate !== "";

  const handleSubmit = async data => {
    const payload = {
      defenseDate: data.defenseDate,
    };

    await dataProvider.customRequest(graduationRequests.thesisDefenseSessionDate(internshipSessionId), payload, "POST");
    notify(`Успешно ${isEdit ? "промяна на" : "добавяне на"} дата на защита`, { type: "success" });
    fetchThesisDefenseInfo();
  };

  return (
    <FormModal
      titleContent={isEdit ? "Промяна на дата на защита" : "Добавяне на дата на защита"}
      onConfirm={handleSubmit}
      defaultValues={{ defenseDate: defenseDate || null }}
      triggerButton={
        <Button
          startIcon={isEdit ? <EditIcon /> : <AddIcon />}
          size="small"
          label={isEdit ? "Промени дата" : "Добави дата"}
          sx={{ mt: 2 }}
        />
      }
    >
      <CustomDateInput
        source="defenseDate"
        label="Дата на защита"
        fullWidth
        noTime
      />
    </FormModal>
  );
};

export default UpdateDateDialog;
